const urlRelatoriosLog = "/v1/RelatoriosDeLog";

const service = {
  methods: {
    $obterRelatorioLogOrganograma(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogOrganograma`, params);
    },
    $obterRelatorioLogCSVOrganograma(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeOrganogramaCsv`, params);
    },
    $obterRelatorioLogPDFOrganograma(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeOrganogramaPDF`, this.$getParamsObject(params));
    },
  }
};

export default service;